import styled from 'styled-components';
import {themecolors} from "../utils/themecolors";

export const WhiteMain = styled.main`
  flex-grow: 1;
  position: relative;
  font-size: 14px;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : '#fff'};
`;

const Main = styled.main`
  flex-grow: 1;
  position: relative;
  font-size: 14px;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : 'transparent'};
`;

export default Main;
